import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { useLock } from '../context/LockContext';
import OrganizationSelector from './OrganizationSelector';
import RestaurantSelector from './RestaurantSelector';
import ChangePinModal from './ChangePinModal';
import Icon from './Icon';
import './UserMenu.css';

function UserMenu({ onClose }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const { hasPin } = useLock();
  const [showChangePinModal, setShowChangePinModal] = useState(false);

  // NER-4030: preferir name/email antes que username (sub/UUID en Google).
  const displayName = user?.name || user?.email || user?.attributes || user?.username;

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
      onClose();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  const handleChangePinClick = () => {
    setShowChangePinModal(true);
  };

  const handleClosePinModal = () => {
    setShowChangePinModal(false);
  };

  return (
    <>
      <div className="user-menu-dropdown">
        <div className="user-menu-header">
          <div className="user-menu-avatar">
            {displayName?.charAt(0).toUpperCase() || <Icon name="person" size="small" />}
          </div>
          <div className="user-menu-info">
            <p className="user-menu-name">{displayName}</p>
            <p className="user-menu-email">{user?.email || user?.attributes || user?.username}</p>
          </div>
        </div>

        <div className="user-menu-divider"></div>

        <div className="user-menu-section">
          <div className="user-menu-section-title">{t('users.organization')}</div>
          <OrganizationSelector />
        </div>

        <div className="user-menu-section">
          <div className="user-menu-section-title">{t('restaurants.restaurant')}</div>
          <RestaurantSelector />
        </div>

        {hasPin && (
          <div className="user-menu-section">
            <div className="user-menu-section-title">{t('lock.security')}</div>
            <button type="button" onClick={handleChangePinClick} className="user-menu-option">
              <Icon name="vpn_key" size="small" className="option-icon" />
              <span>{t('lock.changePin')}</span>
            </button>
          </div>
        )}

        <div className="user-menu-divider"></div>

        <button type="button" onClick={handleLogout} className="user-menu-logout">
          <Icon name="logout" size="small" className="logout-icon" />
          <span>{t('auth.logout')}</span>
        </button>
      </div>

      {showChangePinModal && <ChangePinModal onClose={handleClosePinModal} />}
    </>
  );
}

export default UserMenu;
